export default {
  token: null,
  registerToken: null,
  forgotCheck: false,

  registerCode: null,
  checkNewRegister: false,
  forgotCode: null,

  profile: {},
  address: [],

  factors: [],
  factorById: {},

  factorDetail: [],


  favorites: [],
  favorite: {},

  availableReturnProducts: [],
  returns: [],

  tickets: [],
  ticket: {},

  payBanks: [],

  festivalDiscount: [],
  paymentResult: null,

};
